import { render, staticRenderFns } from "./ProductBrandContent.vue?vue&type=template&id=7f091b86&"
import script from "./ProductBrandContent.vue?vue&type=script&lang=js&"
export * from "./ProductBrandContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports